// ** React Imports
import { useEffect, useRef, useState } from 'react'

// Cubic ease-out, matching the "reenbit" brand motion easing used elsewhere (Key metrics animations).
const easeOut = x => 1 - Math.pow(1 - Math.max(0, Math.min(1, x)), 3)

const ANIM_DURATION = 2600

const statusFor = t => (t < 0.4 ? 'Connecting' : t < 0.85 ? 'Loading workspace' : 'Ready')

const SpinnerComponent = () => {
  const [t, setT] = useState(0)
  const rafRef = useRef(null)

  const run = () => {
    cancelAnimationFrame(rafRef.current)
    const start = performance.now()
    const tick = now => {
      const progress = Math.min(1, (now - start) / ANIM_DURATION)
      setT(progress)
      if (progress < 1) rafRef.current = requestAnimationFrame(tick)
    }
    rafRef.current = requestAnimationFrame(tick)
  }

  useEffect(() => {
    run()
    return () => cancelAnimationFrame(rafRef.current)
  }, [])

  const eIn = easeOut(t * 2.2) // wordmark fade-up
  const eAcc = easeOut((t * 2.2) - 0.35) // "ee" turns cyan
  const eTag = easeOut((t * 2.2) - 0.6) // tagline fade-up
  const barWidth = easeOut(t) * 100

  return (
    <div className='rb-splash'>
      <div className='rb-splash-mark' style={{ opacity: eIn, transform: `translateY(${(1 - eIn) * 28}px)` }}>
        r
        <span className='rb-splash-accent' style={{ color: eAcc > 0.05 ? undefined : '#FFFFFF' }}>
          ee
        </span>
        nbit
      </div>
      <div className='rb-splash-tagline' style={{ opacity: eTag, transform: `translateY(${(1 - eTag) * 16}px)` }}>
        Financial Management System
      </div>

      <div className='rb-splash-progress'>
        <div className='rb-splash-bar'>
          <div className='rb-splash-bar-fill' style={{ width: `${barWidth}%` }} />
        </div>
        <div className='rb-splash-status'>{statusFor(t)}</div>
      </div>

      <button type='button' className='rb-splash-replay' title='Replay' onClick={run}>
        <svg width='14' height='14' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='1.8' strokeLinecap='round' strokeLinejoin='round'>
          <polyline points='1 4 1 10 7 10' />
          <path d='M3.51 15a9 9 0 1 0 2.13-9.36L1 10' />
        </svg>
      </button>
    </div>
  )
}

export default SpinnerComponent
